import { fork } from 'redux-saga/effects';

import { watchApp } from '@/features/App/sagas';
import { watchAuth } from '@/features/Auth/sagas';

export function* rootSaga() {
  yield fork(watchApp);
  yield fork(watchAuth);
}
